module.exports = __webpack_public_path__ + "static/media/SCORE_Logo.55e85664.png";